
import { Listbox, ListboxButton, ListboxOptions } from '@headlessui/vue';
import { useVModel } from '@vueuse/core';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UnderlineSelect',
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
  },
  props: {
    modelValue: {
      type: null,
      required: true,
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(props, { emit }) {
    const selected = useVModel(props, 'modelValue', emit);

    return {
      selected,
    };
  },
});
